// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38atc","largestCol":"styles_largestCol__3L4Fy","smallestCol":"styles_smallestCol__2sjmU"};